<template>
  <div>
    <h4 class="purple text-center">{{$t('marketingCampaigns.notif')}}</h4>
    <div class="row">
      <div class="col-md-6 col-md-offset-1">
        <div class="form-group">
          <p-checkbox v-for="(type, key) in campaignsNotificationTypes"
                v-model="model.notification_types_array[key]"
                :key="key"
                :label="key"
                :inline="true"
                @input="validate"
                name="notification_type">{{$t('campaignsNotificationTypes.' + key)}}</p-checkbox>
          <small style="display:block" class="text-danger" v-if="errors.has('notification_type')">
            {{ getError('notification_type') }}
          </small>
        </div>
      </div>
      <div class="col-md-1 inline-auto pad-rg-0">
        <div class="form-group">
          <label class="control-label inline">{{$t('marketingCampaigns.model')}}</label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <select v-model="model.mode"
                    placeholder="Model"
                    v-validate="modelValidations.mode"
                    class="form-control notof-mode"
                    disabled=""> 
            <option selected="" disabled="" value=""> - {{$t('general.select')}} - </option>  
            <option v-for="(type, key) in campaignsModes"
                      :value="key">{{$t('campaignsModes.' + key)}}</option>        
          </select>
        </div>
      </div>

    <div class="col-md-10 col-md-offset-1" v-if="model.mode == 'AUTO'">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.setHours')}}</label>
          <hr class="sm mar-to-0 mar-bt-0">
          <div class="row" >
            <div class="col-md-4 col-sm-4 col-xs-12 padd" v-for="dayData in model.notification_times_array">
              <p-checkbox
                  v-model="dayData.checked"
                  :key="dayData.day"
                  class="text-purple"
                  :label="dayData.day">{{dayData.day | capitalize}}</p-checkbox>
            
           
              <el-time-select :disabled="!dayData.checked"
                            :placeholder="$t('marketingCampaigns.selectTime')"
                            :value="dayData.hour_from"
                            v-model="dayData.hour_from"
                            v-validate="modelValidations.time"
                            :picker-options="pickerOptions">
              </el-time-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'

  export default {
    props: {
      modelFromParent: {
        type: [Object, Array],
        required: true
      },
      daysParent: {
        type: Array,
        required: true
      }
    },
    watch: {
      modelFromParent (value, oldVal) {
        this.model = value
      },
      daysParent (value, oldVal) {
        this.days = value
      }
    },
    computed: {
      ...mapFields(['notification_types', 'notification_mode', 'email'])
    },
    data () {
      return {
        model: this.value || this.modelFromParent,
        days: this.value || this.daysParent,
        modelValidations: {
          notification_type: {
            required: true
          },
          notification_mode: {
            required: true
          },
          mode: {
            required: true
          },
          time: {
            required: true
          }
        },
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:45'
        },
        campaignsNotificationTypes: [], // this.$session.get('defaultData')['campaigns_notification_types'],
        campaignsModes: []// this.$session.get('defaultData')['campaigns_modes']
      }
    },
    created () {
      // console.warn(this.$session.get('defaultData')['campaigns_notification_types'])
      this.campaignsNotificationTypes = this.$session.get('defaultData')['campaigns_notification_types']
      this.campaignsModes = this.$session.get('defaultData')['campaigns_modes']

      this.$nextTick(function () {
        this.model.mode = 'MANUAL'
      })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        // we need to manually validate the type - and only after that we can do the automatic one
        console.warn(this.model.notification_types_array)
        if (this.model.notification_types_array['EMAIL'] === false && this.model.notification_types_array['PUSH'] === false) {
          this.errors.add('notification_type', 'This field is required.')
          console.warn(this.errors)
          return false
        } else {
          return this.$validator.validateAll().then(isValid => {
            // this.$emit('on-submit', this.registerForm, isValid)
            if (isValid) {
              this.errors.clear()
              return true
            } else {
              return false
            }
          })
        }
        // return this.$validator.validateAll()
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Steps/SecondStep.vue